document.addEventListener('DOMContentLoaded', function() {
    const topDealsList = document.querySelector('.top-deals__list');
    const topDealsItems = topDealsList.querySelectorAll('.top-deals__item');

    if (topDealsItems.length === 1) {
        const mediaQuery = window.matchMedia("(max-width: 1410px)");
        function applyGridStyles(e) {
            if (e.matches) {
              topDealsList.style.gridTemplateColumns = '285px';
            }
        }
        mediaQuery.addListener(applyGridStyles);
        applyGridStyles(mediaQuery);
    }
});